<template>
    
    <DefaultLayout>
        <DefaultHeader :showHeader=true :language="this.lang" />
        <div id="content" class="container-fluid">
            <Grid ref="grid" :columns="columns" :style="{height: '640px', fontSize: '16px'}"
                  :data-items="pagedData" :edit-field="'inEdit'" :sortable="true" :sort="sort"
                  :take="take" :skip="skip" :total="total" :editable="true"
                  :filterable="true" :filter="gridFilter"
                  @filterchange="filterChange" @itemchange="itemChange" @pagechange="pageChange"
                  :pageable="{ buttonCount: 5, info: true, type: 'numeric', pageSizes: true, alwaysVisible: true }"
                  :loader="loader">
                <template v-slot:booleanTemplate="{ props }">
                    <td style="text-align:center">
                        <input type="checkbox" class="custom-checkbox"
                               :checked="props.dataItem && (props.dataItem[props.field] === true || props.dataItem[props.field] === 1)"
                               @change="(e) => onCheckboxChange(e, props)" />
                    </td>
                </template>
                <template v-slot:commandTemplate="{ props }">
                    <td>
                        <div style="display: flex; gap: 8px;">
                            <button v-if="!props.dataItem.inEdit" @click="edit(props.dataItem)">Edit</button>
                            <button v-if="props.dataItem.inEdit" @click="update(props.dataItem)">Save</button>
                            <button v-if="props.dataItem.inEdit" @click="cancel(props.dataItem)">Cancel</button>
                        </div>
                    </td>
                </template>
                <template v-slot:dateEditor="{ props }">
                    <td>
                        {{ formatDate(props.dataItem[props.field]) }}
                    </td>
                </template>
                <grid-norecords> There is no data available custom </grid-norecords>
            </Grid>
        </div>
    </DefaultLayout>
</template>
<style scoped>
    .k-dialog {
        padding: 20px;
        min-width: 600px;
    }

        .k-dialog .k-form {
            font-size: 14px;
        }

    .k-input-value-text.k-input {
        font-size: 14px;
    }
    input.k-input {
        font-size: 14px;
        padding-bottom: 1px;
    }
    textarea.k-input-inner {
        font-size: 14px;
    }
    .k-form-horizontal .k-form-field {
        padding-bottom: 2px;
    }
    .k-form-horizontal .k-form-field > .k-form-label {
        width: 110px;
    }
    .k-form .k-form-field-wrap {
    }
    .k-grid {
        margin: 15px;
        font-size: 14px;
    }
    .k-grid .k-button {
        height: 35px;
        margin: 4px 10px;        
    }
    .k-grid .k-table-th, .k-table-md, .k-grid td, .k-grid .k-table-td {
        font-size: 14px !important;
    }
        .k-grid .k-input {
            height: 32px !important;
            padding: 2px 5px !important;
            font-size: 14px;
        }

    .dp__clear_icon {
        display: none;
    }

    .k-button-solid-primary {
        font-size: 14px;
        background-color: green;
        color: white;
        border-color: green;
    }

    .dp__input, .dp__btn, .dp__cell_inner, .dp__calendar_header_item {
        font-size: 14px;
    }

    .dp__selection_preview {
        font-size: 16px;
    }

    .dp__action_button {
        font-size: 14px;
    }

    .dp--preset-range {
        color: blue;
    }

    .control-group {
        display: flex;
        align-items: flex-start;
        margin: 15px;
        font-size: 14px;
    }

    .dateRange {
        width: 260px;
        padding-left: 10px;
    }

    .k-input-value-text {
        font-size: 14px !important;
    }

    .k-list {
        font-size: 14px;
    }
    .k-tabstrip-items-wrapper .k-item {
        color: blue !important;
    }
    .k-tabstrip-items-wrapper .k-active {
        color: black !important;
    }
    .k-tabstrip-items .k-link {
            font-size: 14px;
        }
    .custom-padding {
        padding-left: 15px;
        display: flex;
        gap:30px;
    }
    .k-button {
        line-height: 22px;
    }
    .custom-checkbox {
        appearance: none;
        -webkit-appearance: none;
        width: 16px;
        height: 16px;
        border: 1px solid #999; 
        background-color: #fff;  
        border-radius: 3px;
        cursor: default;
        position: relative;
        text-align: center;
    }         
        .custom-checkbox:checked {
            background-color: #007bff;  
            border-color: #007bff; 
        }
        .custom-checkbox:checked {
            background-color: #007bff;
            border-color: #007bff;
        }
        /* 🔥 Disabled + checked (force blue) */
        .custom-checkbox:disabled:checked {
            background-color: #007bff !important;
            border-color: #007bff !important;
            opacity: 1 !important; /* remove faded look */
            cursor: default;
        }
        .custom-checkbox:disabled {
            background-color: #fff;
            border-color: #999;
            opacity: 1;  /*prevent grey fade */
        }

            /* Checkmark */
            .custom-checkbox:checked::after {
                content: "";
                position: absolute;
                left: 4px;
                top: 1px;
                width: 4px;
                height: 8px;
                border: solid #fff;   
                border-width: 0 2px 2px 0;
                transform: rotate(45deg);
            }
    .k-filtercell {
        display: none !important;
    }
    .k-filtercell-operator {
        display: none !important;
    }
    .parent-container {
        pointer-events: auto;
    }

</style>
<script>
    import '@progress/kendo-theme-default/dist/all.css';
    import { Grid, GridNoRecords } from '@progress/kendo-vue-grid';
    import { filterBy, orderBy } from '@progress/kendo-data-query';
    import '@vuepic/vue-datepicker/dist/main.css';    
    import DefaultHeader from '../layouts/DefaultHeader.vue';
    import DefaultLayout from '../layouts/DefaultLayout.vue';
    import '@fortawesome/fontawesome-free/css/all.min.css';
    import { store } from '../stores/store.js';
    
    export default {
        name: "PermissionView",
        components: {
            DefaultHeader,
            DefaultLayout,
            Grid: Grid,
            'grid-norecords': GridNoRecords,         
        },
        setup: function () {

        },
        data: function () {
            return {
                today: new Date(),
                filter: null,
                sort: [],
                pageable: true,
                entries: [],
                skip: 0,
                take: 15,
                total: 0,
                updatedData: [],
                editID: null,
                entryInEdit: undefined,            
                columns: [
                  { field: "dateCreated", title: "Date Created", filter: "date", format: "{0:MM/dd/yyyy}", cell: "dateEditor"},
                  { field: "userID", title: "User ID", filter: "numeric",hidden: true },
                  { field: "userName", title: "User Name" },
                  { field: "firstName", title: "First Name" },
                  { field: "lastName", title: "Last Name" },
                  { field: "employeeNumber", title: "Employee #", width: 140 },
                  { field: "isActive", title: "Active", filter: "boolean", encoded: false, cell:"booleanTemplate"}, 
                  { field: "isViewer", title: "Viewer", filter: "boolean", encoded: false, cell:"booleanTemplate"}, 
                  { field: "isApprover", title: "Approver", filter: "boolean", encoded: false, cell:"booleanTemplate"}, 
                  { cell: "commandTemplate" } 
                ],
                loader: false,
                labels: {
                    headerText: 'User Permission'
                },
                gridFilter: {
                    logic: 'and',
                    filters: [],
                },                
            };
        },

        computed: {
            dataState() {
                return {
                    sort: this.sort,
                    skip: this.skip,
                    take: this.take,
                    total: this.total,
                };
            },
            filterEntries: function () {
                return orderBy(filterBy(this.entries, this.gridFilter), this.sort);               
            },
            pagedData: function() {               
                return this.filterEntries.slice(this.skip, this.skip+this.take);
            },
            totalCount() {
                return this.filterEntries.length;
            },
        },
        
        created: function () {
            this.getMainData(true);
        },

        mounted() {
            this.isApprover = store.isApprover;
        },
        methods: {
            filterChange: function (ev) {
                this.gridFilter = ev.filter;
            },
            footerCellRender() {
                return `Total: ${this.totalCount}`;
            },
            clearFilter: function() {
                this.gridFilter = {
                    logic: 'and',
                    filters: [],                                
                }
            },
            pageChange(e) {
              this.take = e.page.take;
              this.skip = e.page.skip;
              this.total = this.filterEntries.length;
            },
            edit(dataItem) {
              this.entries.forEach(item => {
                  item.inEdit = (item === dataItem);
              });
            },              
            itemChange(e) {

                const { field, value, dataItem } = e;
                dataItem[field] = value;
            },
            update(dataItem) {
                dataItem.inEdit = false;

                const payload = { ...dataItem }
                delete payload.inEdit;

                const requestOptions = {
                    method: 'POST', accept: 'application/json', headers: {
                        Accept: 'application/json', 'Content-Type': 'application/json'
                    }, body: JSON.stringify(payload)
                };

                fetch(`/sharpUser/updateUser`, requestOptions)
                    .then(() => {
                        console.log('success');
                    });
            },

            cancel(dataItem) {
                dataItem.inEdit = false;
            },
            onCheckboxChange(e, props) {
              const checked = e.target.checked;

              this.entries = this.entries.map(item =>
                item === props.dataItem
                  ? { ...item, [props.field]: checked }
                  : item
              );
            },
            formatDate(date) {
              if (!date) return '';
              const d = new Date(date);
              const mm = String(d.getMonth() + 1).padStart(2, '0');
              const dd = String(d.getDate()).padStart(2, '0');
              const yy = String(d.getFullYear()).slice(-2);
              return `${mm}/${dd}/${yy}`;
            },
            getMainData: function () {

                const that = this;
                this.loader = true;

                const requestOptions = {
                    method: 'GET', accept: 'application/json', headers: {
                        Accept: 'application/json', 'Content-Type': 'application/json'
                    }
                }

     
                fetch(`/sharpUser/getAllUsers`, requestOptions)
                    .then((response) => response.json())
                    .then((json) => {                       
                        that.entries = json['data'].map(item => {
                                return {
                                    ...item,
                                    dateCreated: item.dateCreated ? new Date(item.dateCreated) : null,
                                    isActive: Boolean(item.isActive),
                                    isViewer: Boolean(item.isViewer),
                                    isApprover: Boolean(item.isApprover),
                                    isAdmin: Boolean(item.isAdmin),    
                                    inEdit: false,
                                };
                            });

                        that.total = this.filterEntries.length;
                        this.loader = false;
                    });
            },
            async loadImageBase64(url) {
                const response = await fetch(url);
                const blob = await response.blob();
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result.split(',')[1]);
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                });
            },
        }
    }
</script>